import { IApprovalDocumentMasterRegistrationTypePayload } from 'pages/ApprovalDocumentGroup/ApprovalDocumentMasterRegistration/type';
import reducer from './reducer';
import * as ApprovalDocMasterRegisSetting from './actions';

export interface InitialApprovalDocMasterRegisSettingType {
  approvalDocMasterDetails: IApprovalDocumentMasterRegistrationTypePayload | undefined,
  extendedInfo: any[];
  passOfApprovalList: {keyWork: string, page: number, size: number};
}


export {
  ApprovalDocMasterRegisSetting,
};

export default reducer;
